import React from "react";
import {
  CalendarIconGray,
  ChatBlackIcon,
  ClockIconGray,
  coachDemoImg,
  LocationIconGray,
  CancelIconBlack,
  FlagIconBlack,
} from "../../../../constant/imagePath";
import Fonts from "../../../../stories/assets/Fonts";
import Colors from "../../../../stories/assets/Colors";
import classes from "./lessonCard.module.css";
import { Col, Row } from "react-bootstrap";
import { ReactSVG } from "react-svg";
import PropTypes from "prop-types";
import moment from "moment";
import { Button } from "../../../../stories/Button/Button";

function LessonCard({ data }) {
  return (
    <div className={classes.card}>
      <div className={classes.contentContainer}>
        <img src={data?.userData?.profile} />

        <Row className={`${classes.content} g-0`}>
          <Col md={12}>
            <h6 style={{ ...Fonts.h6, color: Colors.neutralShadesOfNero }}>
              {`${data?.title} ${data?.type}`}
            </h6>
          </Col>
          <Col md={12}>
            <div
              className={`${[classes.separator, classes.mt12].join(" ")}`}
              style={{ background: Colors.neutralShadesOfGainsboro }}
            />
          </Col>

          <Col md={12} className={classes.dateAndTime}>
            <p
              style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}
              className={classes.aCenter}
            >
              <ReactSVG
                src={CalendarIconGray}
                beforeInjection={(svg) => svg.classList.add(classes.svg)}
              />
              <span
                style={{ ...Fonts.p2, color: Colors.neutralShadesOfNero }}
              >
                {moment(data?.eventDate).format("MMM DD, YYYY")}
              </span>
            </p>
            <p
              style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}
              className={classes.aCenter}
            >
              <ReactSVG
                src={ClockIconGray}
                beforeInjection={(svg) => svg.classList.add(classes.svg)}
              />
              <span
                style={{ ...Fonts.p2, color: Colors.neutralShadesOfNero }}
              >
                {moment(data?.startTime).format("hh:mm A")}
                {"-"}
                {moment(data?.endTime).format("hh:mm A")}
              </span>
            </p>
          </Col>
          <Col md={12} className={classes.mt8}>
            <p
              style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}
              className={classes.location}
            >
              <ReactSVG
                src={LocationIconGray}
                beforeInjection={(svg) => svg.classList.add(classes.svg)}
              />
              <span
                style={{ ...Fonts.p2, color: Colors.neutralShadesOfNero }}
              >
                income {data?.location}
              </span>
            </p>
          </Col>
        </Row>
      </div>

      <div
        className={classes.footer}
        style={{ borderTop: `1px solid ${Colors.neutralShadesOfWhisper}` }}
      >
        <Button
          primary={false}
          icon={
            data?.status == "upcoming"
              ? ChatBlackIcon
              : data?.status == "pending"
                ? CancelIconBlack
                : FlagIconBlack
          }
          size={"Medium"}
          customStyle={{ marginRight: "8px" }}
        />
        <Button
          primary={data?.status == "pending" ? true : false}
          size={"Medium"}
          label={
            data?.status == "upcoming"
              ? "Cancel the lesson"
              : data?.status == "pending"
                ? "Accept"
                : "Evaluate"
          }
          customStyle={{ padding: "14px 24px", width: "max-content", minWidth: '164px' }}
        />
      </div>
    </div>
  );
}
LessonCard.propTypes = {
  data: PropTypes.object,
};
LessonCard.defaultProps = {
  data: {
    start: moment(moment().add(-3, "hours").format())
      .add(0, "days")
      .format("LT"),
    end: moment(moment().add(3, "hours").format()).add(0, "days").format("LT"),
    type: "1-on-1",
    id: 1,
    title: "Tennis Lesson with Jenny",
    eventDate: moment().add(0, "days").format("MMM DD, YYYY"),
    location: "Green Tennis Court",
    // status: "upcoming",
    status: "upcoming",
    user: {
      profile: coachDemoImg,
    },
  },
};

export default LessonCard;
